// extracted by mini-css-extract-plugin
export var container = "search-box-module--container--6d5fa";
export var input = "search-box-module--input--1bb0f";